module.exports = __webpack_public_path__ + "img/e8d2cfd.png";